import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetFilter } from '../selectors/filterSelector'
import DataActions from '../redux/dataRedux'
import getDateFromTimeIso from '../utility/getDateFromTimeIso'

const id = 'LeakDetection'
const authId = 'LeakDetection'
const sourceLayer = 'LeakDetection'
const paintId = 'LeakDetection'
// image%2Fpng
// const URL = ({ idToken, timeIso }) =>
//       `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3ALeakDetection&width=512&height=512&srs=EPSG:3857&format=image%2Fpng;type=mapbox-vector&transparent=true&BBOX={bbox-epsg-3857}&token=${idToken}`
// const URL = ({ idToken, timeIso }) =>
//   `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3ALeakDetection&width=512&height=512&srs=EPSG:3857&format=application/x-protobuf;type=mapbox-vector&transparent=true&BBOX={bbox-epsg-3857}&token=${idToken}`
const URL = ({ timeIso }) => `https://coresight-vector.s3-us-west-2.amazonaws.com/LeakDetection/${encodeURIComponent(
    getDateFromTimeIso(timeIso)
  )}/{z}/{x}/{y}`

export class LeakDetection extends Component {
  componentDidMount () {
    const { map } = this.context
    if (!map) { return }
    map.on('mouseover', id, this.handleMouseOver)
    map.on('mouseout', id, this.handleMouseOut)
    map.on('mousemove', id, this.handleMouseMove)
    map.on('click', id, this.handleClick)
  }

  componentWillUnmount () {
    const { map } = this.context
    if (!map) { return }
    map.off('mouseover', id, this.handleMouseOver)
    map.off('mouseout', id, this.handleMouseOut)
    map.off('mousemove', id, this.handleMouseMove)
    map.off('click', id, this.handleClick)
  }

  handleMouseMove = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })
    
    const data = features.map(feature => feature.properties)
    if (data) {
      actions.dataUpdated(data[0], 'hover')
    }
  }

  handleMouseOut = event => {
    const { map } = this.context

    map.getCanvas().style.cursor = ''
  }
  
  handleMouseOver = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })

    map.getCanvas().style.cursor = features.length > 0 ? 'pointer' : ''
  }

  handleMouseOut = event => {
    const { map } = this.context

    map.getCanvas().style.cursor = ''
  }

  handleClick = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const { features } = event
    if (features.length > 0) {
      console.log(features)
    }
  }

  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps.filter !== this.props.filter) {
      return false    
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, filter } = this.props    
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (
      !isEqual(props.filter, filter)
    ) {
      map.setFilter(id, ['>', 'value', props.filter])
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''

    const vectorSource = {
      type: 'vector',
      tiles: [URL({ idToken, timeIso: time })],
      tileSize: 512,
      minZoom: 13,
      maxZoom: 18
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id={id} tileJsonSource={vectorSource} />
        <Layer
          type='fill'
          id={id}
          filter={['>', 'value', 0]}
          sourceId={id}
          sourceLayer={sourceLayer}
          paint={paint}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getFilter = makeGetFilter()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, paintId),
      time: state.layer.times[id] || undefined,
      datetime: getDatetime(state, id) || '',
      filter: getFilter(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event))
    }
  }
}


export default connect(makeMapStateToProps, mapDispatchToProps)(LeakDetection)



// WEBPACK FOOTER //
// ./src/layers/LeakDetection.js